import React from 'react'
export default class extends React.Component {
	render(){
		return <button className="button search-bar__button" onClick={ function(){ this.props.updateMarkets(); this.props.onClick() }.bind(this) }>Search</button>
	}
}
